export const RECTIFICATION_REQUEST = '/rectification_request/';
export const RECTIFICATION_REQUEST_BY_ID = id =>
  `/rectification_request/${id}/manage`;
